module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/git-2-6d6f4076a487cf10a0ead303078eb961.svg";